import md5 from 'md5'
import axios from 'axios'
import {PATH} from './comcon'


//初始化接口请求参数
function Init(url){
    const timestamp = new Date().getTime()
    const obj = {
        relativeurl: "com.rfid.api." + url,
        caller: "rfid",
        timestamp: timestamp,
        hashcode: md5("rfidrfid@2018" + timestamp)
    }
    return obj
}
//请求接口
function Req(par,callback){
    axios({
        method: 'post',
        url: PATH.PARURL,
        data: JSON.stringify(par),
        transformRequest: [function (data) {return data}],
        transformResponse: [(data)=>{
            callback&&callback(JSON.parse(data));
        }]
    })
}




export {
    Init,
    Req,
}